<script setup>
import { defineEmits } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'None',
  },
  actionIcon: {
    type: String,
    default: '',
  },
  hasAction: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['action']);

const onActionClick = () => {
  if (props.hasAction) {
    emit('action');
  }
};
</script>

<template>
  <div class="relative w-full mb-2">
    <Button
      slate
      outline
      :trailing-icon="!!actionIcon"
      :icon="actionIcon || undefined"
      class="w-full !px-2 transition-colors"
      :class="{
        '!cursor-default': !hasAction,
        'hover:!bg-transparent': !hasAction,
        'hover:!border-slate-200 dark:hover:!border-slate-700': !hasAction,
        '!select-text': !hasAction,

        'cursor-pointer': hasAction,
      }"
      @click="onActionClick"
    >
      <div class="flex items-center justify-between w-full min-w-0">
        <h4
          class="text-sm text-ellipsis overflow-hidden whitespace-nowrap"
          :class="[
            text ? 'text-n-slate-12' : 'text-n-slate-11',
            { '!select-text': !hasAction },
          ]"
          :title="text"
        >
          {{ text || placeholder }}
        </h4>
      </div>
    </Button>
  </div>
</template>
